// Offline / cache-age banner for the floor lookup (S9 §4: "banner shows cache
// age"; §9.14: staleness is surfaced, never hidden). Pure presentational — the
// screen owns connectivity + sync state and passes it in.

import { useTranslation } from "react-i18next";
import { cacheAgeParts } from "../lib/floor-cache-store";

export function CacheBanner({
  online,
  stale,
  syncing,
  syncedAt,
  onRefresh,
}: {
  online: boolean;
  stale: boolean;
  syncing: boolean;
  syncedAt: number | undefined;
  onRefresh: () => void;
}) {
  const { t } = useTranslation();
  const offline = !online || stale;

  const ageLabel =
    syncedAt === undefined
      ? t("catalogue.floorLookup.cacheNever")
      : (() => {
          const parts = cacheAgeParts(Date.now() - syncedAt);
          return t("catalogue.floorLookup.cacheAge", {
            age: t(parts.key, { n: parts.n }),
          });
        })();

  return (
    <div
      className={`floor-banner${offline ? " floor-banner-offline" : " floor-banner-online"}`}
      role="status"
    >
      <span className="floor-banner-state">
        <span className="floor-banner-dot" aria-hidden="true" />
        {offline ? t("catalogue.floorLookup.offline") : t("catalogue.floorLookup.online")}
      </span>
      <span className="floor-banner-age" data-testid="cache-age">
        {syncing ? t("catalogue.floorLookup.syncing") : ageLabel}
      </span>
      <button type="button" className="floor-banner-refresh" onClick={onRefresh} disabled={syncing}>
        {t("catalogue.floorLookup.refresh")}
      </button>
    </div>
  );
}
